import { useState } from "react";
import { usePostApiRequest } from "../../helpers/api";
import InlineSpinner from "../loading/InlineSpinner";
import SuccessModal from "./SuccessModal";
import cogoToast from "cogo-toast";
import NoCodeModal from "../modal/NoCodeModal";
// import LoadingSpinner from "../loading/LoadingSpinner";

const CartTotal = ({
  canOrderPlace,
  totalCartWeight,
  totalCartCarat,
  customerCode,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [customerVerified, setCustomerVerified] = useState(false);
  const [orderPoNo, setOrderPoNo] = useState("");
  const [successData, setSuccessData] = useState({});
  const postApiRequest = usePostApiRequest();

  // const { data: customerDetails, isLoading: isLoadingDetails } = useFetchData(
  //   ["customerDetailsData"],
  //   "/Customer/ClientWiseWT",
  //   { Client_Code: customerId },
  //   null,
  //   { staleTime: Infinity, cacheTime: Infinity, enabled: !!customerId }
  // );

  const handlePlaceOrder = async (e) => {
    e.preventDefault();
    if (!canOrderPlace) {
      return null;
    }

    if (customerCode) {
      setIsLoading(true);

      const apiData = {
        CustomerCode: customerCode,
        OrderPoNo: orderPoNo || "WEBSITE ORDER",
      };

      try {
        const response = await postApiRequest({
          url: "/Customer/CreateQuotation",
          method: "POST",
          data: apiData,
          noToast: true,
        });
        if (response.Status === true) {
          setSuccessData(response.Data[0]);
          setModalShow(true);
        } else {
          cogoToast.error(response.Message);
        }
      } catch (error) {
        console.error("API call failed:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setCustomerVerified(true);
    }
  };

  return (
    <>
      {/* {isLoadingDetails && <LoadingSpinner />} */}
      {/* <div className="col-4 grand-totall">
        <div className="cart_left_top">
          <h3 className="cart-page-title">CLIENT MATERIAL</h3>
        </div>

        <div className="cart_right_middle">
         <div className="cart_right_block">
            <p className="title">GOLD</p>
            <span className="value">
              {customerDetails?.Data?.find((item) => item.RawName === "GOLD")
                ?.Weight || 0}{" "}
              GM
            </span>
          </div> 
          <div className="cart_right_block">
            <p className="title">REQUIRED GOLD</p>
            <span className="value">{totalCartWeight.toFixed(2)} GM</span>
          </div>
           <div className="cart_right_block total_block">
            <p className="title">TOTAL LEFT</p>
            <span className="value">
              {(
                (customerDetails?.Data?.find((item) => item.RawName === "GOLD")
                  ?.Weight || 0) - totalCartWeight
              ).toFixed(2)}{" "}
              GM
            </span>
          </div> 
           <div className="cart_right_block">
            <p className="title">DIAMONDS</p>
            <span className="value">
              {customerDetails?.Data?.find((item) => item.RawName === "DIAMOND")
                ?.Weight || 0}{" "}
              CT
            </span>
          </div> 
          <div className="cart_right_block total_block">
            <p className="title">REQUIRED DIAMONDS</p>
            <span className="value">{totalCartCarat.toFixed(2)} CT</span>
          </div>
          <div className="cart_right_block total_block">
            <p className="title">TOTAL LEFT</p>
            <span className="value">
              {(
                (customerDetails?.Data?.find(
                  (item) => item.RawName === "DIAMOND"
                )?.Weight || 0) - totalCartCarat
              ).toFixed(2)}{" "}
              CT
            </span>
          </div> 
        </div>

        <p className={`cart_bottom_message ${canOrderPlace ? "" : "error"}`}>
          {canOrderPlace
            ? "ORDER CAN BE PROCESSED WITHOUT REQUIRING ADDITIONAL MATERIAL"
            : "ORDER PROCESSING WILL REQUIRE ADDITIONAL MATERIAL"}
        </p>

        <div className="input_con">
          <label htmlFor="cart_po_no">ENTER ORDER PO NO.</label>
          <input
            type="text"
            id="cart_po_no"
            value={orderPoNo}
            placeholder="#"
            onChange={(e) => setOrderPoNo(e.target.value)}
          />
        </div>
        <button
          className={`button primary_btn order_process_btn ${canOrderPlace ? "" : "error"
            }`}
          onClick={handlePlaceOrder}
        >
          {isLoading ? <InlineSpinner /> : "Process Order"}
        </button>
      </div>
      {modalShow && (
        <SuccessModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          successData={successData}
        />
      )}
      {customerVerified && (
        <NoCodeModal
          show={customerVerified}
          onHide={() => setCustomerVerified(false)}
        />
      )} */}
    </>
  );
};

export default CartTotal;
